<script>
  import page from 'page';
  import Dialog from '../../../lib/components/Dialog.svelte';
  import settings from '../../../config';
  import { TS } from '../../../config/translation-keys.js';
  import { t9n } from '../../../lib/translate.js';
  import session from '../../../lib/session.js';
  import router from '../../../lib/router';

  // component options  ------------------------------------------------------ //

  export let profile;
  export let order = null;
  export let is_historical_order = false;

  let showed_profile = {
    avatar_url: '/uploads/profile_images/default-avatar.jpg',
  };

  const display_image = e => {
    let title = !!profile ? profile.display_name : 'Unknown';
    let src = showed_profile.avatar_url;
    let dialog = new Dialog({
      target: document.querySelector('.dialog'),
      props: {
        id: 'user-image-display',
        title: title,
        content: `<img ${src}='../../..' alt='user image' />`,
        buttons: [
          {
            classes: '',
            label: t9n(TS.LOGIN_FORM_CLOSE),
            action: () => {
              dialog.close();
            },
          },
        ],
        open_on_load: true,
        modal: true,
      },
    });
    dialog.open();
  };

  const init_banner = () => {
    let rating;

    showed_profile = {
      completed: profile.completed,
      avatar_url: profile.avatar_url,
      display_name: profile.display_name,
      rating: profile.rating,
      header_role_text: profile.header_role_text,
      user_id: profile.user.id,
    };

    if (profile.role === 'orderer') {
      if (!!order.worker) {
        if (order.worker.worker_profile.overall_rating !== 0) {
          if (order.worker.worker_profile.overall_rating > 0) {
            rating = '+ ' + order.worker.worker_profile.overall_rating;
          } else {
            rating = '- ' + order.worker.worker_profile.overall_rating;
          }
        } else {
          rating = order.worker.worker_profile.overall_rating;
        }

        showed_profile = {
          completed: order.worker.worker_profile.stats.worker_completed_orders,
          avatar_url: order.worker.basic_profile.image_url,
          display_name: `${order.worker.basic_profile.first_name} ${order.worker.basic_profile.last_name}`,
          rating: rating,
          header_role_text: order.worker.basic_profile.organization_name,
          user_id: order.worker.basic_profile.user_id,
        };
      }
    } else {
      if (order.orderer.orderer_profile.overall_rating !== 0) {
        if (order.orderer.orderer_profile.overall_rating > 0) {
          rating = '+ ' + order.orderer.orderer_profile.overall_rating;
        } else {
          rating = '- ' + order.orderer.orderer_profile.overall_rating;
        }
      } else {
        rating = order.orderer.orderer_profile.overall_rating;
      }

      showed_profile = {
        completed: order.orderer.orderer_profile.stats.orderer_completed_orders,
        avatar_url: order.orderer.basic_profile.image_url,
        display_name: display_name(order),
        rating: rating,
        header_role_text: '',
        user_id: order.orderer.basic_profile.user_id,
      };
    }
  };

  function display_name(order) {
    if (order.orderer.basic_profile.organization_name === '') {
      return `${order.orderer.basic_profile.first_name} ${order.orderer.basic_profile.last_name}`
    }
    if (order.orderer.basic_profile.organization_name !== null) {
      return order.orderer.basic_profile.organization_name;
    }

    return `${order.orderer.basic_profile.first_name} ${order.orderer.basic_profile.last_name}`;
  }

  const profile_url_for_order = (order, user_id) => {
    let url = `/profile?order_uuid=${order.order_uuid}&user_id=${user_id}`;

    if (
      (!!order &&
        order.status === 'order_status_initialized' &&
        order.orderer.basic_profile.user_id !== user_id) ||
      is_historical_order
    ) {
      url = 'javascript:;';
    }

    if (
      order.status === 'order_status_initialized' &&
      $session.user.last_role === 'worker'
    ) {
      url = `/profile?order_uuid=${order.order_uuid}&user_id=${user_id}&opp=true`;
    }

    return url;
  };

  const open_chat = async (order, partner_id) => {
    router.navigate(`chats/${order}/partner/${partner_id}`);
  }

  $: if (!!$session && !!profile && !!order) init_banner();
</script>

<table id="user_banner" class={`table user-header ${profile.role}`}>
  <!--<table class={`table user-header ${profile.role}`}>-->
  <tbody>
    <tr>
      <td class="animated bounceInLeft">
      </td>

      <td class="person-info" colspan="2">

        <span class="img-container">
          {#if profile.role === 'orderer' && order.status === 'order_status_initialized'}
            <img
              src={`${settings.api_host}/uploads/profile_images/default-avatar.jpg`}
              alt="avatar"
              class="header-avatar slideInLeft" />
          {:else}
            <a
              class="profile-link"
              on:click={() => {router.navigate(profile_url_for_order(order, showed_profile.user_id))}}>
              <img
                src={settings.api_host + showed_profile.avatar_url}
                alt="avatar"
                class="header-avatar slideInLeft" />
            </a>
          {/if}

        </span>

        {#if profile.role === 'orderer' && (order.status === 'order_status_initialized' || order.status === 'order_status_cancelled_by_orderer' || order.status === 'order_status_cancelled_by_admin')}
          <h4 class="user-name slideInRight">{t9n(TS.ORDER_NO_APPLS)}</h4>
        {:else}
          <h4 class="user-name slideInRight">{showed_profile.display_name}</h4>

          {#if !!showed_profile.header_role_text}
            <div class="user-info slideUp">
              {showed_profile.header_role_text}
            </div>
          {/if}

          <!-- chat message counter  -->

          {#if (profile.role === 'orderer' || profile.role === 'worker') && !is_historical_order && showed_profile.user_id !== $session.user.id}
            <a
              on:click={() => open_chat(order.order_uuid, showed_profile.user_id)}
              id="chat_link"
              class="chat-link slideUp">
              <img src="/assets/messages/message-text.png" alt="chat" />
              <!--{profile.unread_chat_messages_count}-->
              {#if order.unread_chat_messages > 0}
                <span class="badge chat-counter">
                  {order.unread_chat_messages}
                </span>
              {/if}
            </a>
          {/if}
        {/if}
      </td>

      <td class="animated bounceInRight">
      </td>
    </tr>
  </tbody>
</table>

<div class="dialog" />

<style>
  .user-name {
    text-transform: uppercase;
    font-weight: 500;
    margin-bottom: 0;
    margin-top: 5px;
  }

  .user-counters {
    font-size: 25px;
    margin-bottom: 1px;
  }

  .user-info {
    font-size: 14px;
  }

  .profile-link {
      cursor: pointer;
    text-decoration: none;
    color: var(--orderer-foreground-color);
  }

  .chat-link {
    line-height: 4em;
    display: inline-block;
    text-align: center;
    /*width: 100%;*/
    text-decoration: none;
    overflow: hidden;
    margin-bottom: -3em;
    transition: all 0.1s ease-in-out;
    cursor: pointer;
  }

  .chat-link:hover {
    transform: scale(1.25);
  }

  .chat-counter {
    display: inline-block;
    vertical-align: top;
    margin-left: -1em;
    margin-top: 0.5em;
    border: 2px solid white;
  }

  .badge {
    background: #ff6c60;
    font-size: 10px;
    font-weight: normal;
    line-height: 13px;
    padding: 2px 5px;
    position: relative;
    right: 4px;
    top: 1px;
    border-radius: 10px;
    /*-webkit-border-radius: 2px;*/
  }

  .table {
    width: 100%;
    /*margin-bottom: 10px;*/
    border-collapse: collapse;
    table-layout: fixed;
    border-radius: 5px;
    /*border-top-left-radius: 10px;*/
    /*border-top-right-radius: 10px;*/
  }

  .orderer {
    background-color: var(--worker-background-color);
    -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
  }

  .worker {
    background-color: var(--orderer-background-color);
    -webkit-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    -moz-box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
    box-shadow: 1px 1px 15px 0px rgba(0, 0, 0, 0.1);
  }

  .user-header {
    color: white;
    font-size: 14px;
    text-align: center;
  }

  .header-avatar {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-top: 0.6em;
  }

  .header-avatar-zoom {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    margin-top: 0.6em;
  }

  .person-info {
    padding: 1em 0 2em;
  }

  .mapouter {
    position: relative;
    text-align: right;
    height: 500px;
    width: 750px;
  }

  .gmap_canvas {
    overflow: hidden;
    background: none !important;
    height: 500px;
    width: 750px;
  }

  .mdc-dialog .mdc-dialog__surface {
    max-width: 800px;
    width: 800px;
  }

  .btn-showonmap {
    position: relative;
    left: 600px;
    top: -10px;
  }

  .location-text {
    display: inline;
    position: relative;
    top: 20px;
  }

  /*.mdc-dialog .mdc-dialog__surface {*/
  /*    max-width: 800px;*/
  /*    width: 800px;*/
  /*}*/

  /* Desktop mode
      *******************************************************/

  /*
      @media (min-width: 900px) {
        .header-avatar-zoom:hover {
          position:relative;
          left:100px;
          width:300px;
          height:auto;
          display:block;
          z-index:999;
          transition: transform .5s ease;
          transform: scale(1.1);
        }

        .header-avatar-zoom {
          margin-top: 0;
          cursor: pointer;
        }

        .profile-link {
          !* todo: this fixed height might create problems *!
          height: 131px;
          overflow: visible;
        }

      }
    */
</style>
